/**
 * O vocabulário da consultoria de regras com IA ("Pedir melhorias à IA",
 * 2026-10-21): as tarefas que dá pra consultar, os tipos de proposta, o
 * ciclo de status e o desfecho que a pessoa registra.
 *
 * Espelho de `core.vocabulary` (`RULE_REVIEW_TASKS`,
 * `RULE_REVIEW_PROPOSAL_KINDS`, `RULE_REVIEW_STATUSES`/`_ACTIVE_`/`_TERMINAL_`,
 * `RULE_REVIEW_OUTCOMES`, `RULE_REVIEW_MAX_MENTIONS`,
 * `RULE_REVIEW_COMMENT_MAX_LENGTH`), com paridade travada por FONTE em
 * `tests/test_rule_review_vocabulary_parity.py`. As tuplas são `as const` e
 * os rótulos são tipados sobre elas DE PROPÓSITO: chave a menos ou a mais é
 * erro de compilação, não uma linha crua na tela.
 */

/** Quantas menções a consultoria aceita por pedido (decisão da dona: é
 *  consultoria sobre um padrão, não sobre volume). */
export const RULE_REVIEW_MAX_MENTIONS = 30;
/** O teto do comentário da pessoa. */
export const RULE_REVIEW_COMMENT_MAX_LENGTH = 2000;

export const RULE_REVIEW_TASKS = ["polarity_intensity", "role", "themes", "key_message"] as const;
export type RuleReviewTask = (typeof RULE_REVIEW_TASKS)[number];

export const RULE_REVIEW_TASK_LABELS: Record<RuleReviewTask, string> = {
  polarity_intensity: "Polaridade",
  role: "Abordagem",
  themes: "Subtemas",
  key_message: "Mensagens-chave"
};

export const RULE_REVIEW_STATUSES = ["QUEUED", "STARTED", "FINISHED", "ERRORED"] as const;
export type RuleReviewStatus = (typeof RULE_REVIEW_STATUSES)[number];

const ACTIVE: readonly RuleReviewStatus[] = ["QUEUED", "STARTED"];

/** Ainda andando: a tela acompanha por polling até sair daqui. */
export function isRuleReviewActive(status: string): boolean {
  return (ACTIVE as readonly string[]).includes(status);
}

export const RULE_REVIEW_PROPOSAL_KINDS = [
  "rule_update",
  "rule_create",
  "rule_deactivate",
  "theme_add_term",
  "theme_remove_term",
  "theme_set_mode",
  "theme_update_premise",
  "key_message_update_rules"
] as const;
export type RuleReviewProposalKind = (typeof RULE_REVIEW_PROPOSAL_KINDS)[number];

export const RULE_REVIEW_PROPOSAL_KIND_LABELS: Record<RuleReviewProposalKind, string> = {
  rule_update: "Editar premissa",
  rule_create: "Criar premissa",
  rule_deactivate: "Desativar premissa",
  theme_add_term: "Acrescentar termo ao subtema",
  theme_remove_term: "Tirar termo do subtema",
  theme_set_mode: "Trocar o modo do subtema",
  theme_update_premise: "Editar premissa do subtema",
  key_message_update_rules: "Editar critério da mensagem-chave"
};

export const RULE_REVIEW_OUTCOMES = ["applied", "discarded"] as const;
export type RuleReviewOutcome = (typeof RULE_REVIEW_OUTCOMES)[number];

export const RULE_REVIEW_OUTCOME_LABELS: Record<RuleReviewOutcome, string> = {
  applied: "Aplicada",
  discarded: "Descartada"
};
